import {fromJS, List, Map} from 'immutable';

import * as actions from './actions';
import dynamicReducer from '../utilities/dynamic_reducer';


export default function(state = new Map(), action) {
    if (!state.get('elementId'))
        state = state.set('elementId', window.uuidv4());
    if (!state.get('data'))
        state = state.set('data', new List());
    if (state.get('beginning') === undefined)
        state = state.set('beginning', null);
    if (!state.get('totalCount'))
        state = state.set('totalCount', 0);
    if (!state.get('messages'))
        state = state.set('messages', new List());
    if (!state.get('selected'))
        state = state.set('selected', new Map());
    if (!state.get('sorts'))
        state = state.set('sorts', new List());
    if (action.elementId === state.get('elementId')) {
        switch (action.type) {
        case actions.SET_DATA:
            state = state.set('data', fromJS(action.payload));
            break;

        case actions.UPDATE_ITEM:
            if (state.get('data').some(
                item => item.get('id') == action.payload.id,
            )) {
                state = state.updateIn(
                    ['data', state.get('data').findIndex(
                        item => item.get('id') == action.payload.id,
                    )],
                    () => fromJS(action.payload),
                );
            }
            if (state.get('selected').some(
                item => item.get('id') == action.payload.id,
            )) {
                state = state.updateIn(
                    ['selected', state.get('selected').findKey(
                        item => item.get('id') == action.payload.id,
                    )],
                    () => fromJS(action.payload),
                );
            }
            break;

        case actions.ADD_ITEM:
            if (state.get('beginning') !== 0)
                break;
            state = state.updateIn(
                ['data'],
                new List(),
                data => {
                    if (data.count() >= action.pageSize) {
                        data = data.pop();
                    }
                    data = data.unshift(fromJS(action.payload));
                    return data;
                },
            );
            state = state.set('totalCount', state.get('totalCount') + 1);
            break;

        case actions.REMOVE_ITEM:
            state = state.updateIn(
                ['data'],
                new List(),
                data => data.remove(data.findIndex(item => item.get('id') === Number(action.payload))),
            );
            state = state.set('totalCount', state.get('totalCount') - 1);
            break;

        case actions.SET_SELECTION:
            state = state.set('selected', state.get('selected').clear());
            action.payload.forEach(item => state = state.setIn(
                ['selected', Number(item.id)],
                fromJS(item),
            ));
            break;

        case actions.TOGGLE_SELECTION:
            const id = Number(action.payload.id);
            if (state.get('selected').get(id)) {
                state = state.removeIn(
                    ['selected', id],
                );
            }
            else {
                state = state.setIn(
                    ['selected', id],
                    fromJS(action.payload),
                );
            }
            break;

        case actions.CLEAR_SELECTION:
            state = state.set('selected', state.get('selected').clear());
            break;

        case actions.SET_SORT:
            state = state.set('sorts', fromJS(action.payload));
            break;

        case actions.SET_BEGINNING:
            state = state.set('beginning', action.payload);
            break;

        case actions.SET_TOTAL_COUNT:
            state = state.set('totalCount', action.payload);
            break;

        case actions.SET_SEARCH_TERM:
            state = state.set('searchTerm', action.payload);
            break;

        case actions.SHOW_MESSAGE:
            state = state.set('messages', state.get('messages').push(fromJS(action.payload)));
            break;

        case actions.FADE_MESSAGE: {
            const index = state.get('messages').findIndex(
                message => action.payload.id
                    ? message.get('id') === action.payload.id
                    : message.get('message') === action.payload,
            );
            if (index !== -1)
                state = state.setIn(['messages', index, 'fade'], true);
            break;
        }

        case actions.HIDE_MESSAGE:
            const index = state.get('messages').findIndex(
                message => action.payload.id
                    ? message.get('id') === action.payload.id
                    : message.get('message') === action.payload,
            );
            if (index !== -1)
                state = state.removeIn(['messages', index]);
            break;
        }
    }
    state = state.set('edit', dynamicReducer(state.get('edit'), action));
    return state;
}
